
import { Assessment, Category } from '@/types/assessment';

// Filter out categories with no questions for the free assessment
export function getFreeCategoriesWithQuestions(assessment: Assessment): Category[] {
  // Filter out categories with no questions for the free assessment
  const freeCategories = assessment.categories.filter(
    category => category.questions.some(q => !q.premium && !q.disabled)
  );
  
  // Get only the free, non-disabled questions for each category
  const categoriesWithFreeQuestions = freeCategories.map(category => ({
    ...category,
    questions: category.questions.filter(q => !q.premium && !q.disabled)
  }));
  
  // Sort categories by order if available
  return [...categoriesWithFreeQuestions].sort((a, b) => {
    if (a.order !== undefined && b.order !== undefined) {
      return a.order - b.order;
    }
    return 0;
  });
}

// Calculate progress percentage based on fully completed questions
// (both current and target answered for maturity questions)
export function calculateProgressPercentage(
  totalQuestions: number, 
  completedQuestionsCount: number
): number {
  return totalQuestions > 0 ? Math.round((completedQuestionsCount / totalQuestions) * 100) : 0;
}

// Check if a question is fully answered (both current and target for maturity)
export function isQuestionFullyAnswered(response: any): boolean {
  if (!response) return false;
  
  if (Array.isArray(response.current) && Array.isArray(response.target)) {
    return response.current.length > 0 && response.target.length > 0;
  }
  
  return true;
}

// Calculate the number of completed questions in a category
export function getCompletedQuestionsCountInCategory(
  categoryQuestions: any[],
  responses: Record<string, any>
): number {
  return categoryQuestions.filter(question => 
    isQuestionFullyAnswered(responses[question.id])
  ).length;
}

// Get category progress percentage based on completed questions
export function getCategoryProgressPercentage(
  categoryQuestions: any[],
  responses: Record<string, any>
): number {
  const totalQuestions = categoryQuestions.length;
  if (totalQuestions === 0) return 0;
  
  const completedCount = getCompletedQuestionsCountInCategory(categoryQuestions, responses);
  return calculateProgressPercentage(totalQuestions, completedCount);
}
